import { merge } from 'lodash';
import production from './production';

export default merge({}, production, {
  logoIcon: 'SoteriaLogo',
  domainName: 's-neptune.com',
});
